import type { PageArticleFieldsFragment } from "@/components/contentful/page-article/__generated/page-article.contentful.generated";
import type { PageBasicFieldsFragment } from "@/components/contentful/page-basic/__generated/page-basic.contentful.generated";
import { IntroContent } from "@/components/intro-content";
import { WrapperContainer } from "@/components/wrapper-container";
import { richTextRenderer } from "@/lib/contentful/rich-text-renderer/rich-text-renderer";
import { ModuleRenderer } from "@/lib/contentful/modules/ModuleRenderer";
import { Box, Grid, GridItem } from "@project/ui";
import { gridGap, gridTemplateColumns } from "@project/ui/src/theme/global-styles";
import { ModuleQuickLinks } from "@/components/contentful/module-quick-links/module-quick-links";

type ArticleContentProps = PageArticleFieldsFragment | PageBasicFieldsFragment;

export const ArticleContent = ({
    bodyText,
    modulesCollection,
    ...restProps
}: ArticleContentProps) => {
    return (
        <Box as="article" pt={{ base: 10, l: 20 }}>
            <IntroContent hasTopPadding={false} {...restProps} />
            {restProps.__typename === "PageBasic" && restProps.introQuickLinks && (
                <ModuleQuickLinks {...restProps.introQuickLinks} />
            )}
            <WrapperContainer>
                <Grid templateColumns={gridTemplateColumns} gap={gridGap}>
                    {bodyText && (
                        <GridItem
                            colStart={{ base: 1, l: 4 }}
                            colEnd={{ base: 3, l: 10 }}
                            mb={{ base: 10, l: 20 }}
                        >
                            <Box className="rte">{richTextRenderer(bodyText)}</Box>
                        </GridItem>
                    )}
                </Grid>
            </WrapperContainer>
            {modulesCollection?.items.map(
                (module, index) =>
                    module && (
                        <ModuleRenderer
                            componentProps={module}
                            key={module.sys.id + crypto.randomUUID()}
                            index={index}
                        />
                    )
            )}
        </Box>
    );
};
